var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIncidentOutages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 0a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h14zm-4.304 2.143a.752.752 0 0 0-.936.043l-6.004 5.25A.752.752 0 0 0 4.23 8.75h2.636l-1.804 4.204a.75.75 0 0 0 1.185.86l6.004-5.25a.715.715 0 0 0 .188-.829.707.707 0 0 0-.682-.485H9.14l1.804-4.204a.749.749 0 0 0-.249-.903z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncidentOutages);
export default __webpack_public_path__ + "static/media/incident-outages.2a951b37e6e6f290959daf4902742818.svg";
export { ForwardRef as ReactComponent };